'use client';

import Link from 'next/link';
import { useTranslation } from '@/hooks/useTranslation';
import { FaChevronRight } from 'react-icons/fa';
import { config } from '@/config/config';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const { lang } = useTranslation();

  return (
    <nav className="flex flex-wrap items-center text-sm text-muted-foreground mb-4 gap-2
    ">
      <Link href={`/${lang}`} className="hover:text-primary transition-colors">
        {config.app.name}
      </Link>
      {items.map((item, index) => (
        <span key={item.label} className="flex items-center gap-2">
          <FaChevronRight className="w-3 h-3" />
          {item.href && index < items.length - 1 ? (
            <Link href={item.href} className="hover:text-primary transition-colors">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground">{item.label}</span>
          )}
        </span>
      ))}
      <div id='breadcrumb-end'></div>
    </nav>
  );
} 